import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { ApiError, MessageService } from '../../../../core';
import { ClienteCentralCompraV1HttpService } from './cliente-central-compra-v1-http.service';
import { ClienteCentralCompraV1 } from './cliente-central-compra-v1';
import { Cliente } from '../cliente';

@Component({
    selector: 'sgt-cliente-central-compra-v1',
    templateUrl: './cliente-central-compra-v1.component.html',
    styleUrls: ['./cliente-central-compra-v1.component.less']
})
export class ClienteCentralCompraV1Component implements OnInit {
    @Input() idCliente: number;
    @Input() entity: Cliente;
    @Output() entityChange = new EventEmitter<Cliente>();
    @Input() incluirCentralCompra = true;
    @Input() isCadastroCliente = false; // Se o component estiver no cadastro do cliente

    isCentralCompra: boolean;
    clientesVinculados: ClienteCentralCompraV1[];

    @ViewChild('containerClienteVinculados') containerClienteVinculados: ElementRef;
    isCollapsedIn = false;

    constructor(private router: Router,
                private messageService: MessageService,
                private clienteCentralCompraV1HttpService: ClienteCentralCompraV1HttpService) { }

    ngOnInit() {
        // Primeiramente verificamos se o cliente é uma Central de Compras que possui outros clientes vinculados a ela
        this.isCentralCompraComClientesVinculados(this.idCliente)
            .then(isCentralCompra => {
                this.isCentralCompra = isCentralCompra;
                if (this.isCentralCompra) { // Se for uma Central de Compras, então pesquisamos os clientes vinculados a ela
                    this.searchClientesVinculadosCentralCompra(this.idCliente);
                } else if (this.entity) { // Se não for, então pesquisamos os clientes vinculados a Central de Compras selecionada
                    this.searchClientesVinculadosCentralCompra(this.entity.id);
                }
            })
            .catch(() => {});
    }

    /** Verifica se deve exibir os clientes vinculados */
    isShowClientesVinculados(): boolean {
        if (this.isCentralCompra) {
            return true;
        }

        return this.entity !== null && this.entity !== undefined;
    }

    /** Verifica se o cliente informado é uma Central de Compras que possui algum cliente vinculado a ela */
    private isCentralCompraComClientesVinculados(idCliente: number): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.clienteCentralCompraV1HttpService.isCentralCompraComClientesVinculados(idCliente)
                .subscribe(
                    response => resolve(response),
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao verificar se o cliente é uma Central de Compra', error);
                        reject();
                    }
                )
        });
    }

    /** Pesquisa os clientes vinculados a Central de Compra informada através do seu ID */
    private searchClientesVinculadosCentralCompra(idCliente: number) {
        this.clienteCentralCompraV1HttpService.searchClientesVinculadosCentralCompra(idCliente, this.incluirCentralCompra)
            .subscribe(
                entities => {
                    this.clientesVinculados = entities;
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar os clientes vinculados a Central de Compra', error)
            );
    }

    /** Ao alterar a Central de Compras selecionada */
    onClienteCentralCompra(entity: Cliente) {
        this.entityChange.emit(entity);
        // Se não for uma Central de Compra e tiver a central de compra selecionada
        if (!this.isCentralCompra && entity) {
            this.searchClientesVinculadosCentralCompra(entity.id);
        }
    }

    toggleClientesVinculados() {
        jQuery(this.containerClienteVinculados.nativeElement).slideToggle(400, () => {
            this.isCollapsedIn = !this.isCollapsedIn;
        });
    }

    open(clienteVinculado: ClienteCentralCompraV1) {
        if (!clienteVinculado) {
            return;
        }

        this.router.navigate(['clientes', 'cadastro', clienteVinculado.id]);
        // Se estiver no cadastro do cliente, é necessário fazer um reload no navegador pois o angular não atualiza os dados somente alterando o id no path
        if (this.isCadastroCliente) {
            setTimeout(() => location.reload(), 200);
        }
    }

    /** Desvincula o cliente da sua Central de Compra */
    desvincularCentralCompra(clienteVinculado: ClienteCentralCompraV1) {
        if (!clienteVinculado) {
            return;
        }

        this.messageService.confirm('Deseja realmente desvincular este cliente da sua Central de Compra?', 'Confirme').then(result => {
            if (result) {
                this.clienteCentralCompraV1HttpService.desvincularCentralCompra(clienteVinculado.id)
                    .subscribe(
                        response => {
                            this.messageService.success(null, response);

                            if (this.isCentralCompra) {
                                this.searchClientesVinculadosCentralCompra(this.idCliente);
                            } else if (this.entity) {
                                this.searchClientesVinculadosCentralCompra(this.entity.id);
                            }
                        },
                        (error: ApiError) => this.messageService.error(error.message, 'Erro ao desvincular o cliente da Central de Compra', error)
                    );
            }
        });
    }
}
